import { render, staticRenderFns } from "./StaGis.vue?vue&type=template&id=4eb2dccd&scoped=true"
import script from "./StaGis.vue?vue&type=script&lang=js"
export * from "./StaGis.vue?vue&type=script&lang=js"
import style0 from "./StaGis.vue?vue&type=style&index=0&id=4eb2dccd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb2dccd",
  null
  
)

export default component.exports